// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QmDd","top":"styles_top__3H9_Y","left":"styles_left__1o9Fb","description":"styles_description__23keY"};